import BaseModelAPI from '../BaseModelAPI';

export default class EmployeeStatus extends BaseModelAPI {
	static entity = 'employeestatus';
	static entityName = 'employeestatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}